import Vue from 'vue'
import Router from 'vue-router'
import HomeTraCuu from '@/components/HomeTraCuu.vue'
import NotFound from '@/components/NotFound.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/permission',
      component: NotFound
    },
    {
      path: '/tra-cuu/:type/:documentTypeCode/:documentStatusCode/:stateDisplay',
      component: HomeTraCuu,
      props: true
    },
    {
      path: '/tra-cuu/:type/:documentTypeCode/:documentStatusCode/:stateDisplay/:id',
      component: HomeTraCuu,
      props: true
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js